import ReportFiles from "./ReportFiles.vue";

module.exports = [
    {path: '/files/report-files', component: ReportFiles, meta: {title: 'Report Files'}},
]